import { render } from "./PlanManage.vue?vue&type=template&id=0a18fbd4"
import script from "./PlanManage.vue?vue&type=script&lang=js"
export * from "./PlanManage.vue?vue&type=script&lang=js"

import "./PlanManage.vue?vue&type=style&index=0&id=0a18fbd4&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__